// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f9","2739": "e59be614","5336": "5083bc52","8857": "629e5669","8942": "f06e52cc",}[chunkId] + ".css"
}